import { useEffect, useRef } from "react";

import { queryClient } from "app/providers/QueryProvider";
import { isAuthenticated } from "helpers/authSession";
import {
  clearSessionAuthError,
  getSessionAuthErrorMessage,
} from "helpers/sessionExpiredNotifier";
import { tokenUtils } from "utils";

const useSessionTokenRecovery = () => {
  const lastTokenRef = useRef(tokenUtils.getToken());

  useEffect(() => {
    const syncAfterTokenChange = () => {
      const nextToken = tokenUtils.getToken();

      if (nextToken === lastTokenRef.current) {
        return;
      }

      lastTokenRef.current = nextToken;

      if (!getSessionAuthErrorMessage() || !isAuthenticated()) {
        return;
      }

      clearSessionAuthError();
      queryClient.invalidateQueries();
    };

    const intervalId = window.setInterval(syncAfterTokenChange, 1500);

    return () => window.clearInterval(intervalId);
  }, []);
};

export default useSessionTokenRecovery;
